var canhidezoom=false;
var loadtimeout;

var digitalgolf = {
	'timeouts': {
	},
	'setup': {
		'useExponentialSlider': true,
		'useInfiniteLoader': true,
		'mapstyles': [ { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#c2c2c2" } ] },{ "featureType": "road.highway.controlled_access", "elementType": "geometry.fill", "stylers": [ { "color": "#808080" } ] },{ "featureType": "landscape", "elementType": "geometry", "stylers": [ { "color": "#dddddd" } ] },{ "featureType": "poi.park", "stylers": [ { "color": "#bababa" } ] },{ "featureType": "water", "stylers": [ { "color": "#b1c2cf" } ] },{ "featureType": "road.highway.controlled_access", "elementType": "geometry.stroke", "stylers": [ { "color": "#6a6a6a" } ] },{ "featureType": "poi", "stylers": [ { "visibility": "off" } ] },{ "featureType": "road.highway.controlled_access", "elementType": "labels.text.fill", "stylers": [ { "color": "#323435" } ] },{ "featureType": "road.highway.controlled_access", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] },{ } ]
	},
	'l10n': {
		'cartAdded': "Produkt bol pridaný<br />do košíka"
	},
	'pageData': {
		'filter_extra': ""
	},
	'form': {
		'setupLabels': function() {
			$('.form_item.checkbox, .form_item.radio').each(
				function(){
					if ($(this).find('input').is(':checked')) {
						$(this).addClass('checked');
					}else{
						$(this).removeClass('checked');
					}
				}
			);
			return true;
		},
		'input': {
			'help': {
				'show': function(elem) {
					$(elem).parent().find('.help[rel="' + $(elem).attr('name') + '"]').show();
					return true;
				},
				'hide': function(elem) {
					$(elem).parent().find('.help[rel="' + $(elem).attr('name') + '"]').hide();
					return true;
				}
			}
		}
	},
	'toolbox': {
		'cookie': {
			'get': function(cookieName) {
				var nameEQ = cookieName + "=";
				var ca = document.cookie.split(';');
				for(var i=0;i < ca.length;i++) {
					var c = ca[i];
					while (c.charAt(0)==' ') c = c.substring(1,c.length);
					if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
				}
				return null;
			},
			'set': function(cookieName, value, days) {
				var expires = '';
				if (days) {
					var date = new Date();
					date.setTime(date.getTime() + (days*24*60*60*1000));
					expires = "; expires=" + date.toGMTString();
				}
				document.cookie = cookieName + "=" + value + expires + "; path=/";
			},
			'erase': function (cookieName) {
				digitalgolf.toolbox.cookie.set(cookieName,"",-1);
			}
		},
		'getOrigin': function() {
			if (document.location.origin) {
				return document.location.origin;
			}else{
				return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
			}
		},
		'getDomainSuffix': function()
		{
			if (cyclone3.domain_name.indexOf("fr.") >= 0) {
				return cyclone3.domain_name.replace('.digitalgolf.com','');
			} else {
				return cyclone3.domain_name.replace('digitalgolf.','');
			}
		},
		'setUri': function(params) {
			document.location.href = digitalgolf.toolbox.getOrigin() + document.location.pathname + '?' + params;
		},
		'setUriHash': function(params) {
			params = params.replace(/^#+/,'');
			document.location.hash = params;
		},
		'objectifyParams': function(paramString) {
			var paramArray = paramString.split('&');
			var paramObject = {};
			
			for (var i = 0; i < paramArray.length; i++)
			{
				if (!paramArray[i]) {
					continue;
				}
				var paramSplit = paramArray[i].split('=');
				paramSplit[1] = digitalgolf.toolbox.uriDecode(paramSplit[1]);
				if (paramSplit[1].match(';')) {
					paramSplit[1] = paramSplit[1].split(';');
				}
				paramObject[paramSplit[0]] = paramSplit[1];
			}
			
			return paramObject;
		},
		'getUriParams': function(loc){
			var paramString = '';
			
			if (digitalgolf.setup.useInfiniteLoader) {
				paramString = loc.hash.replace(/^#+/,'');
			}else{
				paramString = loc.search.substring(1);
			}
			var paramArray = paramString.split('&');
			var paramObject = {};
			
			//cyclone3.log('[toolbox.getUriParams] paramArray:');
			//cyclone3.log(paramArray);
			
			for (var i = 0; i < paramArray.length; i++)
			{
				if (!paramArray[i]) {
					continue;
				}
				var paramSplit = paramArray[i].split('=');
				cyclone3.log('merde1 ' + paramSplit[1]);
				paramSplit[1] = digitalgolf.toolbox.uriDecode(paramSplit[1]);
				cyclone3.log('merde2 ' + paramSplit[1]);
				if (paramSplit[1].match(';')) {
					paramSplit[1] = paramSplit[1].split(';');
				}
				paramObject[paramSplit[0]] = paramSplit[1];
			}
			
			//cyclone3.log('[toolbox.getUriParams] paramArray:');
			//cyclone3.log(paramObject);
			
			return paramObject;
		},
		'uriEncode': function(val) {
			return encodeURIComponent(val.replace(/ /g, "+"));
		},
		'uriDecode': function(val) {
			return decodeURIComponent(val.replace(/\+/g, " "));
		},
		'moveTo': function(where) {
			if (where=='filter_top')
			{
				$('html, body').scrollTop($('.site_frame .filter').offset().top - 120);
			}
		},
		'scrollTo': function(where) {
			if (where=='filter_top')
			{
				$('html, body').animate({
					scrollTop: ($('.site_frame .filter').offset().top - 120)
				},300);
			}
		},
		'getLinkLng': function()
		{
			var linkLng = cyclone3.lng + '/';
			if (
					( cyclone3.domain_name == 'digitalgolf.sk' && cyclone3.lng=='sk')
				||	( cyclone3.domain_name == 'digitalgolf.cz' && cyclone3.lng=='cs')
				||	( cyclone3.domain_name == 'digitalgolf.at' && cyclone3.lng=='de-AT')
				||	( cyclone3.domain_name == 'digitalgolf.com' && cyclone3.lng=='en')
				||	( cyclone3.domain_name == 'fr.digitalgolf.com' && cyclone3.lng=='fr')
				||	( cyclone3.domain_name == 'digitalgolf.de' && cyclone3.lng=='de-AT')
			)
			{
				linkLng = '';
			}
			return linkLng;
		},
		'setupLabels': function()
		{
			if ($('.label_check input').length) {
				 $('.label_check').each(function() { 
					  $(this).removeClass('c_on');
				 });
				 $('.label_check input:checked').each(function() { 
					  $(this).parent('label').addClass('c_on');
				 });                
			}
			if ($('.label_radio input').length) {
				 $('.label_radio').each(function() { 
					  $(this).removeClass('r_on');
				 });
				 $('.label_radio input:checked').each(function() { 
					  $(this).parent('label').addClass('r_on');
				 });
			}
			
			$('.col_l aside nav ul.menu a').each(function()
			{
				 $(this).prop('href', modify_hash_url($(this).prop('href'), window.location.hash));
			});
		},
		'checkMailFormat': function(email)
		{
			return /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/.test( email );
		}
	},
	'order': {
		'cart': {
			'add': function(elem, ID, amount, price, variant, action, replace)
			{
				if(!amount){
					amount = 1;
				}
				
				//_gaq.push(['_trackEvent', 'Basket', 'Add', ID.toString(), price]);
				
				if (replace)
				{
					$.ajax(
					{
						type: "GET",
						url: cyclone3.domain + '/xml/' + cyclone3.lng + '/order/cart/action?action=rem&ID=' + replace,
						dataType: 'xml',
						xhrFields: {
							withCredentials: true
						},
						success: function(data){
							try{
								digitalgolf.product.cart.add(elem, ID, amount, price, action);
							}catch(e){
								cyclone3.log('[order.cart.add] error ' + e);
							}
							
							digitalgolf.order.cart.update();
						}
					});
				}
				else
				{
					$.ajax(
					{
						type: "GET",
						url: cyclone3.domain + '/xml/' + cyclone3.lng + '/order/cart/action?action=add&amount=' + amount + '&ID=' + ID,
						dataType: 'xml',
						xhrFields: {
							withCredentials: true
						},
						success: function(data){
							try{
								digitalgolf.order.cart.update();
							}catch(e){
								cyclone3.log('[order.cart.add] error ' + e);
							}
							
                            //update info inside popup
                            $('#popup_amount').text(amount);
                            $('#popup_price').text(price);
                            $('#popup_variant').text(variant);

							//popup show - added to cart
							$('[data-js-popup="cart-added"], #mask').fadeIn(200).addClass('open');

                            //pridame classu aby sa nam nescroloval body
                            $(document.body).addClass('scroll-stop');

                            //odstranujeme sctoll-stop ak klikneme na zavriet alebo mimo popupu
                            $('#mask.open, [data-js-popup-dismiss]').click(function(){
                                $(document.body).removeClass('scroll-stop');
                            })
						}
					});
				}
				g_addToCart('#item_product_' + ID, amount); 
			},

			'increase': function(elem, ID, UID)
			{
				//_gaq.push(['_trackEvent', 'Basket', 'Increase', ID.toString()]);
				
				var uri_suffix='';
				
				if (UID) {
					uri_suffix='&uid='+UID;
				}
				
				$.ajax(
				{
					type: "GET",
					url: cyclone3.domain + '/xml/' + cyclone3.lng + '/order/cart/action?action=add&ID=' + ID + uri_suffix,
					dataType: 'xml',
					xhrFields: {
						withCredentials: true
					},
					success: function(data){
						try{
							digitalgolf.order.cart.update();
						}catch(e){
							cyclone3.log('[order.cart.increase] error ' + e);
						}
					}
				});
			},
			'decrease': function(elem, ID, UID)
			{
				var uri_suffix='';
				
				if (UID) {
					uri_suffix='&uid='+UID;
				}
				
				//_gaq.push(['_trackEvent', 'Basket', 'Decrease', ID.toString()]);
				
				$.ajax(
				{
					type: "GET",
					url: cyclone3.domain + '/xml/' + cyclone3.lng + '/order/cart/action?action=dec&ID=' + ID + uri_suffix,
					dataType: 'xml',
					xhrFields: {
						withCredentials: true
					},
					success: function(data){
						try{
							digitalgolf.order.cart.update();
						}catch(e){
							cyclone3.log('[order.cart.decrease] error ' + e);
						}
					}
				});
			},
			'remove': function(ID, UID) {
				//_gaq.push(['_trackEvent', 'Basket', 'Remove', ID.toString(), price]);
				
				var uri_suffix='';
				
				if (UID) {
					uri_suffix='&uid='+UID;
				}
				
				$.ajax(
				{
					type: "GET",
					url: cyclone3.domain + '/xml/' + cyclone3.lng + '/order/cart/action?action=rem&ID=' + ID + uri_suffix,
					dataType: 'xml',
					xhrFields: {
						withCredentials: true
					},
					success: function(data){
						try{
							digitalgolf.order.cart.update();
						}catch(e){
							cyclone3.log('[order.cart.remove] error ' + e);
						}
					}
				});
				g_removeFromCart(ID); 
			},
			'update': function(dontPopup) {
				$.ajax(
				{
					type: "GET",
					url: cyclone3.domain
						+ '/'
						+ digitalgolf.toolbox.getLinkLng()
						+ 'chunk/cart',
					dataType: 'html',
					xhrFields: {
						withCredentials: true
					},
					success: function(data){
						try{
							$('[data-cart-sum]').replaceWith($(data).find('[data-cart-sum]'));
							$('[data-cart-items]').replaceWith($(data).find('[data-cart-items]'));
							$('[data-cart-summary]').replaceWith($(data).find('[data-cart-summary]'));
							
							createOwlSlider();
							
							if (!dontPopup) {
								$('#site_head .cart').trigger('mouseenter');
							}
						}catch(e){
							cyclone3.log('[order.cart.update] error ' + e);
						}
					}
				});

			}
		}
	},
	'product': {
		'set': {
			'addCartTooltip': {
				'attach': function(){
					$(".product_main > .button.addtocart").tipper({
						direction: "left",
						formatter: function(target)
						{
							return $(target).data('stock_note');
						}
					});
				},
				'detach': function(){
					$(".product_main > .button.addtocart").tipper("destroy");
				},
			},
			'recalculatePrice': function() {

			}
		},
		'cart': {
			'getCount': function () {
				cyclone3.log('[product.cart.getCount]');
				$.ajax(
				{
					type: "GET",
					url: cyclone3.domain + '/xml/' + cyclone3.lng + '/order/cart/action',
					dataType: 'xml',
					xhrFields: {
						withCredentials: true
					},
					success: function(data){
						try
						{
							digitalgolf.product.cart.updateCount(data);
						}catch(e){
							cyclone3.log('[product.cart.getCount] error ' + e);
						}
					}
				});
			},
			'updateCount': function (data) {
				cyclone3.log('[product.cart.updateCount]');
				var count = $(data).find('cart count').text();
				if(!count){
					count='0';
				}
				$('#cart_container .counter span')
					.html(
						count
					);
				$('#cart_container .info')
					.html(
						$(data).find('cart info').text()
					)
					.parent().removeClass('empty');
				$('#cart_container_responsive').html($('#cart_container .info').clone());
			},
			'add': function(elem, ID, amount, price, action, replace){

			}
		},
		'facet': {
			'config': {
				'uri': '',
				'minItems': 20,
				'firstLoad': true,
				'pendingRequests': 0,
				'pendingTimer': null,
			},
			'initialize': function(initial) {
				
				digitalgolf.product.facet.config.pendingRequests++;				
				var uri_hash='', uri_hash_for_filters='';		
				
				if (!document.location.hash) {
					uri_hash = digitalgolf.product.filter.getParams();
				} else {
					var tmpRange = document.location.hash.match(/price_range=([,0-9]+)/);
					
					if (tmpRange) {
						tmpRange = tmpRange[1].split(',');
						if (tmpRange[0].match(/\d+/)) {
							$("#price_min").val(tmpRange[0]);
						}
						if (tmpRange[1].match(/\d+/)) {
							$("#price_max").val(tmpRange[1]);
						}
					}
					
					uri_hash = document.location.hash.replace(/^#+/,'&');
					uri_hash_for_filters = document.location.hash.replace(/^#+/,'');
					if (!uri_hash.match(/q=/) && digitalgolf.product.filter.getSearchQuery())
					{
						//uri_hash = uri_hash + '&q=' + digitalgolf.product.filter.getSearchQuery();
					}
				}
				
				cyclone3.log('[product.facet.initialize] uri_hash');
				cyclone3.log(uri_hash);
				
				//ak tu toto nie je rozbije sa multiselect
				uri_hash = uri_hash.replace(/;/g,'%3b');
								
				var tmp = digitalgolf.product.facet.config.uri + uri_hash;				
				if ($('#main').data('brand_id') && $('#main').data('brand_name_url'))
				{					
					tmp = tmp+'&brand='+$('#main').data('brand_name_url')
				}
				$.ajax
				(
					{
						type: "GET",
						url: tmp,
						dataType: "json",
						xhrFields: {
							withCredentials: true
						},
						success: function(json)
						{
							var facet = $('#facet');
							$.each(json.fields, function(key, param) {
								
								var field = key.replace(/^.*?\./,'').replace(/^p_/,'');
								
								if (field == "price" || field == "main") {
									return;
								}
								
								try{
									if (field=='VPrznack' && digitalgolf.pageData.brand.name)
									{
										return;
									}
								}
								catch(e)
								{
									//do nothing, just catching bad stuff
								}
								
								if(param.count == "0")
								{
									return;
								}

								var output =
								'<div class="dropdown">'
									+'<button class="dropdown-toggle" type="button" id="size-button">' + param.label +'</button>'
									+'<form class="dropdown-menu"  id=p_'+field+'>'
										+'<div class="content">';
								
								$.each(param.items, function(name, item) {									
									var checked = '';
									if (item.checked == 'true') {
										checked = ' checked="checked"';
									}
									output +=
									'<div class="custom-control custom-checkbox">'
										+'<input '
											+' name="'+field+'_'+name+'"'
											+' id="'+field+'_'+name+'"'
											+' value="'+name+'"'
											+ checked
											+' type="checkbox" />'
										+'<label class="custom-control-label" for="'+field+'_'+name+'">'+item.label+'</label>'
									+'</div>';										
								});						
								
								output += '</div>'
									+'<button class="button save" data-form="p_'+field+'">' + $('.product__filter').data('submit-text') + '</button>'
									+'</form>'
								+'</div>'
									
								$(output).appendTo(facet);
							});
														
							if (uri_hash) {
								digitalgolf.product.facet.update(uri_hash_for_filters);
							} else if (digitalgolf.pageData.page > 1) {
                                digitalgolf.product.list.load();
                            }
						}
					}
				);
			},
			'update': function(uri_params_2)
			{
				var uri_params;
				if (uri_params_2) {
					cyclone3.log('[product.facet.update] uri_params_2');
					cyclone3.log(uri_params_2);
					digitalgolf.product.facet.config.pendingRequests++;
					digitalgolf.toolbox.setUriHash(uri_params_2); 
					uri_params = uri_params_2;
					var regexp = /(&p_main=)(.*)/;
					var result = uri_params.match(regexp);
					if (result) {
						var uri_params_parsed = result[2].split("%3B");
						for (i in uri_params_parsed) {
							if ($("#p_main_"+uri_params_parsed[i]).length) {
								$("#p_main_"+uri_params_parsed[i]).prop('checked', true);
							}
						}
					}
				}
				digitalgolf.product.facet.config.pendingRequests++;
			
				digitalgolf.toolbox.setUriHash(digitalgolf.product.filter.getParams()); 
				uri_params = digitalgolf.product.filter.getParams();
				if ($('#main').data('brand_id') && $('#main').data('brand_name_url'))
				{					
					uri_params = uri_params+'&brand='+$('#main').data('brand_name_url')
				}
				
				$.ajax({
					type: "GET",
					url: digitalgolf.product.facet.config.uri + uri_params,
					dataType: "json",
					xhrFields: {
						withCredentials: true
					},
					success: function(json)
					{
						var enabledItems={};						
						$.each(json.fields, function(key, param) {
									
							var field = key.replace(/^.*?\./,'').replace(/^p_/,'');
							if (field == "price" || field == "main") {
								return;
							}
							
							$.each(param.items, function(name, item) {
								enabledItems[name] = item.count;
							});
							
							$('#facet form[id=\'p_'+field+'\'] input[type=\'checkbox\']').each(
								function()
								{
									var count = 0;
									if(enabledItems[$(this).attr('value')])
									{
										$(this).attr('disabled', false);
										$(this).parent().removeClass('disabled');
									} else {
										$(this).attr('disabled', true);
										$(this).parent().addClass('disabled');										
									}
								}
							);
						});
						
						digitalgolf.product.list.load();
					}
				});
			}
		},
		'filter': {
			'getSearchQuery': function() {
				return $('#asideSearch input[name="q"]').val();
//				return $('#facet input[name="q"]').val();
			},
			'getParams': function () {
				var parametre= "";
				
				if(digitalgolf.product.filter.getSearchQuery())
				{
					parametre = parametre + '&q=' + digitalgolf.product.filter.getSearchQuery();
				}
				
				$("#facet form").each
				(
					function()
					{
						var fieldsetname = $(this).attr("id");
						
						if (fieldsetname == 'other')
						{
							//chod cez vsetky chceckboxy a checkuj
							
							$(this).find('input').each(
								function(){
									if(this.checked){
										var tmpName = $(this).attr('name').replace(/(^p_.*?)_.*?$/,'$1');
										
										parametre = parametre+"&";
										parametre =  parametre + tmpName;
										parametre =  parametre + "=";
										parametre =  parametre + encodeURIComponent(this.value).replace(/%20/g,'+').replace(/ /g,'+');
									}
								}
							);
						}
						else
						{
							//chod cez vsetky chceckboxy a checkuj
							var values='';
							$(this).find('input').each(
								function(){
									if(this.checked){
										if(values){ values = values + encodeURIComponent(";"); }
										values = values + encodeURIComponent (this.value);
									}
								}
							);
							
							//input each
							
							if (values!=='')
							{
								parametre = parametre+"&";
								parametre =  parametre +fieldsetname;
								parametre =  parametre + "=";
								parametre =  parametre + values.replace(/%20/g,'+').replace(/ /g,'+');
							}
						}
					}
				);
				
				var main_values = "";
				$("form#filterTop input[type='checkbox']").each(function(){		
					if ($(this).is(':checked')) 
					{
						main_values += $(this).val()+encodeURIComponent(";");
                    }			
				});
				if (main_values!=='')
				{						
					parametre = parametre+"&p_main=" + main_values.replace(/%20/g,'+').replace(/ /g,'+');;
				}
				
				if ($("#price_min").val() || $("#price_max").val()) {
					parametre = parametre+"&price_range="+$("#price_min").val()+','+$("#price_max").val();
				}
				
				return parametre;
			}
		},
		'list':	{
			'load': function(hashparams) {
				
				$('#main').css('opacity','.4');
				$('.product_list .loader').css('visibility','visible');
				
				cyclone3.log('[product.list.load] start', 10);
				var param_offset=0;
				var match_;
				
				setupUrlPage(digitalgolf.pageData.page);				
				if (digitalgolf.pageData.page > 1)
				{
					param_offset = (digitalgolf.pageData.page-1) * digitalgolf.pageData.page_limit_more; // -1 lebo ludske ratanie je od 1, ale logicke chceme 0 
                }
				
				if (hashparams && (match_ = hashparams.match(/page_offset=([0-9]+)/)))
				{
					cyclone3.log('[product.list.load] page hash contains offset: ' + match_[1]);
					param_offset=match_[1];
					hashparams=hashparams.replace(/(page_offset=[0-9]+&?)/g,'');
				}
				if (hashparams)
				{
					hashparams = hashparams.replace(/&&/g,'&');
					hashparams=hashparams.replace(/&$/g,'');
				}
				
				cyclone3.log('[product.list.load] hashparams='+hashparams);
				var isBrand="";
				if ($('#main').data('brand_id') && $('#main').data('brand_name_url'))
				{					
					isBrand = '&brand_ID_entity='+$('#main').data('brand_id')+'&brand_name_url='+$('#main').data('brand_name_url')
				}
				
				$.ajax(
				{
					type: "GET",
					url: cyclone3.domain
						+ '/'
						+ digitalgolf.toolbox.getLinkLng()
						+ 'chunk/products?node=' + digitalgolf.pageData.nodeId
						+ '&page_offset=' + param_offset + '&page_limit=' + digitalgolf.pageData.page_limit_more
						+ '&sort=' + $("#sort").val()
						+ '&q=' + ($('aside input[name="q"]').val() || '')
						+ '&' + (hashparams || digitalgolf.product.filter.getParams()) + digitalgolf.pageData.filter_extra
						+ isBrand,
					dataType: 'html',
					xhrFields: {
						withCredentials: true
					},
					success: function(data){
						try
						{
							cyclone3.log('[product.list.load] success', 10);

							$('ul.filter-tags').empty();							
							$(data).find('ul.filter-tags li').each(function(){
								$('ul.filter-tags').append(this);
							});

							$('#main').empty();
							
							$(data).find('#main > *, .no_items').each(function(){
								$('#main').append($(this));
							});
							
							cyclone3.log('[product.list.load] previous offset: ' + $(data).find('#main + .paging_wrap .previous').data('list_offset'));
							cyclone3.log('[product.list.load] next offset: ' + $(data).find('#main + .paging_wrap .next').data('list_offset'));
							
							$('#main')
								.data('list_offset', $(data).find('#main').data('list_offset'))
								.data('list_remaining', $(data).find('#main').data('list_remaining'))
								.data('list_page', $(data).find('#main').data('list_page'))
								.data('list_count', $(data).find('#main').data('list_count'));
							
							digitalgolf.pageData.page_next_offset = parseInt($(data).find('#main').data('list_offset')) + parseInt($(data).find('#main').data('list_pagelimit'));
							
							if($(data).find('#main').data('list_remaining')>0){
								
							}else{
								$('button#load-more').hide();
							}
							
							if($(data).find('#main').data('list_remaining')>0){
								$('button#load-more').text($(data).find('#main').data('more_string'));
								$('button#load-more').show();
							}else{
								$('button#load-more').hide();
							}							
							
							// reinitialize .store
							$('.item_stock.store').mouseover(function(){
								$(this).tipsy({
									'title': function(){
										return $(this).html();
									},
									'className': 'store_availability',
									'html': true,
									'trigger': 'manual',
									'gravity': 'south'
								});
								$(this).tipsy('show');
							}).mouseout(function(){
								$(this).tipsy('hide');
							});
							
							digitalgolf.product.facet.config.pendingRequests--;
							
							window.clearTimeout(digitalgolf.product.facet.config.pendingTimer);
							
							$.getScript(cyclone3.domainMedia + '/eshop_js/cart_add_simple.js');
							$('.product_list .loader').css('visibility','hidden');
							$('#main').css('opacity','100');
						}catch(e){
							alert(e);
						}
					},
					complete: function(data){
						// update pagination - pagination.js
						updatePagination();
					}
				});
			},
			'loadMore': function()
			{
				cyclone3.log('[product.list.loadMore]', 10);
				
				// create loading
				$('#load-more').attr('disabled', true).addClass('loading').append(`<span class="skeleton__loader skeleton__loader--button"></span>`);
				
				var current_url = new URL(window.location);
				if (current_url.searchParams.get('page')){
					var page = parseInt(current_url.searchParams.get('page'));
					digitalgolf.pageData.page_next_offset = page * digitalgolf.pageData.page_limit_default;
				}
				if(typeof(digitalgolf.pageData.page_next_offset) === "undefined"){
					digitalgolf.pageData.page_next_offset = digitalgolf.pageData.page_limit_default;
				}
				var isBrand="";
				if ($('#main').data('brand_id') && $('#main').data('brand_name_url'))
				{					
					isBrand = '&brand_ID_entity='+$('#main').data('brand_id')+'&brand_name_url='+$('#main').data('brand_name_url')
				}
				
				$.ajax(
				{
					type: "GET",
					url: cyclone3.domain
						+ '/'
						+ digitalgolf.toolbox.getLinkLng()
						+ 'chunk/products?node=' + digitalgolf.pageData.nodeId
						+ '&page_offset=' + digitalgolf.pageData.page_next_offset
						+ '&page_limit=' + digitalgolf.pageData.page_limit_more
						+ '&page_limit_more=' + digitalgolf.pageData.page_limit_more
						+ '&' + digitalgolf.product.filter.getParams() + digitalgolf.pageData.filter_extra
						+ isBrand,
					dataType: 'html',
					xhrFields: {
						withCredentials: true
					},
					success: function(data){
						try
						{
							
							$('ul.filter-tags').empty();							
							$(data).find('ul.filter-tags li').each(function(){
								$('ul.filter-tags').append(this);
							});
														
							$(data).find('#main > *').each(function(){
								$('#main').append(this);
							});
							
							$('#main')
								.data('list_offset', $(data).find('#main').data('list_offset'))
								.data('list_remaining', $(data).find('#main').data('list_remaining'))
								.data('list_page', $(data).find('#main').data('list_page'))
								.data('list_count', $(data).find('#main').data('list_count'));

							var current_page = digitalgolf.pageData.page_next_offset/digitalgolf.pageData.page_limit_more;
							setupUrlPage(current_page+1); // +1 because human count start from 1 not from 0							

							digitalgolf.pageData.page_next_offset = parseInt($(data).find('#main').data('list_offset')) + parseInt($(data).find('#main').data('list_pagelimit'));
							
							if($(data).find('#main').data('list_remaining')>0){
								$('button#load-more').text($(data).find('#main').data('more_string'));
								$('button#load-more').show();
							}else{
								$('button#load-more').hide();
							}
							
							// remove loading
							$('#load-more').attr('disabled', false).removeClass('loading');
							$('#load-more').find(".skeleton__loader").remove();
							
							$('.item_stock.store').mouseover(function(){
								$(this).tipsy({
									'title': function(){
										return $(this).html();
									},
									'className': 'store_availability',
									'html': true,
									'trigger': 'manual',
									'gravity': 'south'
								});
								$(this).tipsy('show');
							}).mouseout(function(){
								$(this).tipsy('hide');
							});
							
						}catch(e){
							alert(e);
						}
					},
					complete: function(data){
						// update pagination - pagination.js
						updatePagination();
					}
				});
			},
			'searchTimer' : null,
			'timeoutKeyUp': null,
			'search': function() {
				$('#site_head .search').addClass('loading');
				
				$.ajax(
				{
					type: "GET",
					url: cyclone3.domain
						+ '/'
						+ digitalgolf.toolbox.getLinkLng()
						+ 'chunk/search?'
						//+ 'page_offset=' + digitalgolf.pageData.page_next_offset
						//+ '&page_limit=' + digitalgolf.pageData.page_limit_more
						//+ '&page_limit_more=' + digitalgolf.pageData.page_limit_more
						+ '&q=' + ($('#headsearch_query').val() || '')
						//+ '&' + digitalgolf.product.filter.getParams() + digitalgolf.pageData.filter_extra
						,
					//data: {
					//	'node' : digitalgolf.pageData.nodeId,
					//	'page_offset' : getStart()
					//},
					dataType: 'html',
					xhrFields: {
						withCredentials: true
					},
					success: function(data){
						try
						{
							cyclone3.log($('#search_wrapper .items'));
							cyclone3.log($(data).find('.items'));
							$('#search_wrapper .items').empty();
							$('#search_wrapper .items').append($(data).find('.items').html());
							$('#search_wrapper .summary').empty();
							$('#search_wrapper .summary').hide();
							if ($(data).find('.summary').html()) $('#search_wrapper .summary').show();
							$('#search_wrapper .summary').append($(data).find('.summary').html());

							// ecommerce measurement 
							$('#search_wrapper .items .item').on("click", function(){ dataLayerEventSearch($('#headsearch_query').val() || '', 'suggest', $(data).find('.items').data('items-count') || '', $(data).find('.items').data('cats-count') || '')})
							//ak uzivatel neklikne na vylistovane itemy do 2 sekund, odoslem event search do GTM
							if (digitalgolf.product.list.timeoutKeyUp) {
								clearTimeout(digitalgolf.product.list.timeoutKeyUp);
							}
							digitalgolf.product.list.timeoutKeyUp = setTimeout(function () {
								dataLayerEventSearch($('#headsearch_query').val() || '', 'suggest', $(data).find('.items').data('items-count') || '', $(data).find('.items').data('cats-count') || '');
							}, 2000);
							
						}catch(e){
							alert(e);
						}
					},
					complete: function(){
						$('#site_head .search').removeClass('loading');
					}
				});
			},
			'searchMore_url': function()
			{
				var url;
				if(typeof(digitalgolf.pageData.page_next_offset) === "undefined"){
					digitalgolf.pageData.page_next_offset = digitalgolf.pageData.page_limit_default;
				}
				url = cyclone3.domain
					+ '/'
					+ digitalgolf.toolbox.getLinkLng()
					+ 'chunk/search?'
					+ '&page_offset=' + digitalgolf.pageData.page_next_offset
					+ '&page_limit=' + digitalgolf.pageData.page_limit_more
					+ '&page_limit_more=' + digitalgolf.pageData.page_limit_more
					+ '&q=' + ($('.page_frame input[name="q"]').val() || '');
				return url;
			},
			'searchMore': function()
			{
				if(typeof(digitalgolf.pageData.page_next_offset) === "undefined"){
					digitalgolf.pageData.page_next_offset = digitalgolf.pageData.page_limit_default;
				}
				$.ajax(
				{
					type: "GET",
					url: cyclone3.domain
						+ '/'
						+ digitalgolf.toolbox.getLinkLng()
						+ 'chunk/search?'
						+ 'page_offset=' + digitalgolf.pageData.page_next_offset
						+ '&page_limit=' + digitalgolf.pageData.page_limit_more
						+ '&page_limit_more=' + digitalgolf.pageData.page_limit_more
						+ '&q=' + ($('.page_frame input[name="q"]').val() || '')
						//+ '&' + digitalgolf.product.filter.getParams() + digitalgolf.pageData.filter_extra
						,
					//data: {
					//	'node' : digitalgolf.pageData.nodeId,
					//	'page_offset' : getStart()
					//},
					dataType: 'html',
					xhrFields: {
						withCredentials: true
					},
					success: function(data){
						try
						{
							var productList = $('.page_frame .product_list > ul');
							$(data).find('#main > li').each(function(){
								$(productList).append(this);
							});
							//cyclone3.log($(data));
							$('#main')
								.data('list_start', $(data).find('#main').data('list_start'))
								.data('list_offset', $(data).find('#main').data('list_offset'))
								.data('list_remaining', $(data).find('#main').data('list_remaining'))
								.data('list_count', $(data).find('#main').data('list_count'));
							
							digitalgolf.pageData.page_next_offset = parseInt($(data).find('#main').data('list_offset')) + parseInt($(data).find('#main').data('list_pagelimit'));
							
							if($(data).find('#main').data('list_remaining')>0){
								$('.product_container .paging button').show();
								//$('.product_container .paging button').text($(data).find('.paging').find('button').text());
								$('.product_container .paging button').text($(data).find('#main').data('more_string'));
							}else{
								$('.product_container .paging button').hide();
							}
						}catch(e){
							alert(e);
						}
					}
				});
			}
		},
	},
	'banner': {
		'view': function(banner){
			$.ajax({
				type: "GET",
				url: cyclone3.domain + '/json/' + digitalgolf.toolbox.getDomainSuffix() + '/' + cyclone3.lng + '/900v',
				data: {
					'id' : banner
				},
				xhrFields: {
					withCredentials: true
				},
			});
		},
		'click': function(banner){
			$.ajax({
				type: "GET",
				url: cyclone3.domain + '/' + cyclone3.lng + '/service/click',
				data: {
					'id' : banner
				},
				xhrFields: {
					withCredentials: true
				},
			});
		},
		'popup': {
			'minScreen': {
				'width': 500,
				'height': 500
			},
			'processDefault': function(content) {
				
			},
			'processCenter': function(content, bid) {
				var popupBlock = $('<div class="popup popup_banner">'
					+ '<div class="popup_banner--container">'
					+ '<a class="close" href="#">close</a>'
//					+ $(content).html()
					+ content
					+ '</div>'
					+ '</div>').css({
						'visibility': 'hidden',
					}).appendTo('body');
				
				var bannerContent = $(popupBlock).find('.popup_banner--content ');
								
				$(popupBlock).click(function(){
					digitalgolf.banner.popup.closeCenter();
				});
				
				var imgs = $(bannerContent).find("img"),
					len = imgs.length;

				var fireAway = function ()
				{
					$('body').append($(popupBlock));
					$(popupBlock).hide().css('visibility','visible').fadeIn(500);
					digitalgolf.banner.view(bid);
				};
				
				if (len)
				{
					imgs.one('load', function()
					{
						len--;
						//now all images loaded
						if (len === 0)
						{							
							fireAway();
						}
					}).each(function()
					{
						 if (this.complete)
							  $(this).load();
					});
				}
				else
				{
					fireAway();
				}
			},
			'closeCenter': function() {
				$('.popup_banner').fadeOut('fast', function(){
					$('.popup_banner').remove();
				});
			},
		},
	},
};

function modify_hash_url(current_url, new_hash)
{
	 var hash_position = current_url.search('#');
	 var new_url = '';
	 
	 if (hash_position > -1)
	 {
			new_url = current_url.substring(0, hash_position) + new_hash;
	 }
	 else
	 {
			new_url = current_url + new_hash;
	 }
	 
	 return new_url;
}

function set_header(new_class, header_pos_l)
{
	$('#site_head').removeClass().addClass(new_class);

	set_cart_position(header_pos_l);
}
	
function set_cart_position(header_pos_l)
{
	var offset     = parseInt($('.site').css('padding-top'), 10);
	var scrolled   = $(document).scrollTop();
	var cart       = $('.mini_cart');
	var main       = $('.main');
	var header_cls = $('#site_head').attr('class');
	var margin_l   = header_pos_l;
}

/*
 * Zoradenie produktov do mriezky
 */
function createGrid() {
	function findPosition(object) {
		var col_r_w = $("body").width() - $(".col_l").width();
		if(col_r_w > 998) {
			col_r_w = 998;
		}
		var num_cols = parseInt(col_r_w / product_w);
		var pos = [];
		for(var y=0;; y++) {
			if(grid[y] === undefined) {
				grid[y] = [];
			}
			if(grid[y+1] === undefined) {		// alokujem aj dalsi riadok
				grid[y+1] = [];
			}

			for(var x=0; x<num_cols; x++) {
				if(object.is('.wide')) {
					if(x+1>=num_cols || grid[y][x+1] !== undefined) {
						continue;
					}
				}
				if(object.is('.tall')) {
					if(grid[y+1][x] !== undefined) {
						continue;
					}
				}
				if(object.is('.wide.tall')) {
					if(x+1>=num_cols || grid[y+1][x+1] !== undefined) {
						continue;
					}
				}
				if(grid[y][x] === undefined) {
					pos.y = y;
					pos.x = x;
					grid[y][x] = 1;
					if(object.is('.wide')) {
						grid[y][x+1] = 1;
					}
					if(object.is('.tall')) {
						grid[y+1][x] = 1;
					}
					if(object.is('.wide.tall')) {
						grid[y+1][x+1] = 1;
					}
					return pos;
				}
			}
		}
	}
	var grid = [[]], product_h = 150, product_w = 124;

	$('.product_list.grid .product').each(function() {
		var pos = findPosition($(this));
		$(this).css({
			position:'absolute',
			margin:'',
			top:pos.y*product_h,
			left:pos.x*product_w
		});
	});
}

function createOwlSlider()
{
	var owl = $("#owl");
	
	owl.owlCarousel(
	{
		loop: false,
		autoplay: false,
		nav: false,
		dots: false,
		responsive:{
			0:{
				items: 1
			},
			600:{
				items: 3
			},
			1000:{
				items: 4
			},
			1200:{
				items: 5
			}
		},
		afterAction: afterOwlSliderAction
	});

	// Custom Navigation Events
	$(".next").click(function(){
		owl.trigger('next.owl.carousel');;
	});
	$(".prev").click(function(){
		owl.trigger('prev.owl.carousel');
	});
}

function afterOwlSliderAction()
{
	var prevBtn = $('.customNavigation .btn.prev');
	var nextBtn = $('.customNavigation .btn.next');
	
	// first item (not) visible -> prev button
	switch (this.owl.visibleItems[0])
	{
		case 0: prevBtn.css('visibility', 'hidden');
			break;
		default: prevBtn.css('visibility', 'visible');
			break;
	}
	
	// last item (not) visible -> next button
	switch (this.owl.visibleItems[this.owl.visibleItems.length - 1])
	{
		case (this.owl.owlItems.length - 1): nextBtn.css('visibility', 'hidden');
			break;
		default: nextBtn.css('visibility', 'visible');
			break;
	}
	
}

var googleMapCounter = 0;

function initGoogleMaps() {
	$('.googlemap').each(function(){
		if ($(this).data('latlong'))
		{
			var mapid = 'googlemap_'+googleMapCounter;
			$(this).attr('id',mapid);
			
			var latLng = $(this).data('latlong').split(',');
			
			var mapOptions = {
				zoom: 15,
				center: new google.maps.LatLng(latLng[0], latLng[1]),
				styles: digitalgolf.setup.mapstyles,
				//styles: [ { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#c2c2c2" } ] },{ "featureType": "road.highway.controlled_access", "elementType": "geometry.fill", "stylers": [ { "color": "#808080" } ] },{ "featureType": "landscape", "elementType": "geometry", "stylers": [ { "color": "#dddddd" } ] },{ "featureType": "poi.park", "stylers": [ { "color": "#bababa" } ] },{ "featureType": "water", "stylers": [ { "color": "#b1c2cf" } ] },{ "featureType": "road.highway.controlled_access", "elementType": "geometry.stroke", "stylers": [ { "color": "#6a6a6a" } ] },{ "featureType": "poi", "stylers": [ { "visibility": "off" } ] },{ "featureType": "road.highway.controlled_access", "elementType": "labels.text.fill", "stylers": [ { "color": "#323435" } ] },{ "featureType": "road.highway.controlled_access", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] },{ } ],
				//mapTypeId: google.maps.MapTypeId.SATELLITE,
				//draggable: false,
				zoomControl: true,
				//scrollwheel: false
				//disableDoubleClickZoom: true
			};
			
			// Get the HTML DOM element that will contain your map 
			// We are using a div with id="map" seen below in the <body>
			var mapElement = document.getElementById(mapid);
			
			// Create the Google Map using out element and options defined above
			var map = new google.maps.Map(mapElement, mapOptions);
			
			var image = '/media/grf/map_marker.png';
			var myLatLng = new google.maps.LatLng(latLng[0], latLng[1]);
			new google.maps.Marker({
				 position: myLatLng,
				 map: map,
				 icon: image
			});
			
			googleMapCounter++;
		}
	});
}

function initYouTubeVideos()
{
	 $('.a030_youtube').each(function()
	 {
			var vid_res   = { 'width': $(this).width(), 'height': $(this).height() };
			var vid_id    = $(this).attr('id');
			var id_regexp = /a030_youtube:ID=([a-z0-9_]+)/i;
				 vid_id    = vid_id.match(id_regexp);

			$(this).replaceWith('<iframe width="' + vid_res['width'] + '" height="' + vid_res['height'] + '" src="https://www.youtube.com/embed/' + vid_id[1] + '" frameborder="0" allowfullscreen></iframe>');
	 });
}

/* facet expand/contract */

function slideUpslideDown()
{
	$('dt').click(
		function()
		{
			//cyclone3.log("test");
			var dl = $("dl"); // najdeme rodica, co je element u uroven vyssie, ktory obsahuje element, na ktory sme klikli
			//dd = $("dd");   // dieta je element nasledujuci po tom, na ktory sme pravy klikli
			//dt = $("dt");
			
			dl.find('dd').hide();
			//dt.addClass('aa');
				
			$('dt').click(
				function()
				{	
					$('dt').addClass('aa');
					dl.find('dd').show();
					return false;
				}
			);
			
			return false;
		}
	);
}


/* facet expand/contract */

function moreless()
{
	$('dl').each
	(
		function()
		{
			$(this)
				.find('dd')
				.hide()
				.filter(':lt('+(digitalgolf.product.facet.config.minItems)+')')
				.show();
		}
	);
}


$(document).ready(
	function()
	{
		if ($('body').hasClass('sizetable'))
		{
			if (window.location.hash)
			{
				var tmpHash = decodeURI(window.location.hash.replace(/^#+/,''));
				console.log(tmpHash);
				console.log('body > .site .site_frame .styled_text a[name="' + tmpHash + '"]');
				var tmpAnchor = $('body > .site .site_frame .styled_text a[name="' + tmpHash + '"]')[0];
				console.log(tmpAnchor);
				if (tmpAnchor)
				{
					$('html, body').animate({scrollTop : $(tmpAnchor).offset().top - $('#site_head').height() - 20},300);
				}
			}
		}
		
		$(document).keyup(function(e) {
			if (e.keyCode == 27) { // escape key maps to keycode `27`
				digitalgolf.banner.popup.closeCenter();
			}
		});
		$('body').addClass('has-js');
		
		$('.label_check, .label_radio').click(function() {
			digitalgolf.toolbox.setupLabels();
		});
		
		digitalgolf.toolbox.setupLabels();
		
		$('.form_item.checkbox, .form_item.radio').click(
			function()
			{ digitalgolf.form.setupLabels(); }
		);
		
		digitalgolf.form.setupLabels();

		//menu a zobrazovanie spravnych widgetov
		function isActiveTab()
		{
			if( $('.driversTabs > ul > li:first-child()').hasClass('active') )
			{
				$('.driversMenuInfo').show();
				$('.driversMenuCustom').hide();
				$('.strana, .moznosti, #selected_modification').show();
				$('#order_button_config').hide();
				$('#order_button_d').show();
				$('#order_button').hide();
				$('#order_button_set').show();
				$('.shaft_type_price').html('0.00&nbsp;&euro;');
				$('.grip_price').html('0.00&nbsp;&euro;');

				//zobrazenie options menu pri vybere konfiguratora
				$('.product_modifications').find('.selecter-selected').show();
				$('.product_modifications').find('header').val('Options').show();
			}
			else if ( !$('.driversMenuCustom').length ) 
			{
				$('.driversMenuInfo').show();
				$('.strana, .moznosti').show();
				if($('#order_button_config').length && $('#order_button_d').length)
				{
					$('#order_button_config').hide();
				}
			}
			else
			{
				$('.driversMenuInfo').hide();
				$('.driversMenuCustom').show();
				$('.strana, .moznosti, #selected_modification').hide();
				$('#order_button_config').show();
				$('#order_button_d').hide();
				$('#order_button').hide();
				$('#order_button_set').hide();

				//skrytie options menu pri vybere konfiguratora
				$('.product_modifications').find('.selecter-selected').hide();
				$('.product_modifications').find('header').html('Options').hide();
			}

			if($('.product_main').length && $('#order_button_set').length && $('.driversTabs > ul > li:first-child()').hasClass('active')) {
				$('#custom_fit').addClass('setProduct');
			}
			else {
				$('#custom_fit').removeClass('setProduct');
			}

		}

		isActiveTab();


		$(document).on('click', '.driversTabs > ul > li', function(e){
			e.preventDefault();

			if( !$(this).hasClass('active') )
			{
				$('.driversTabs > ul > li').removeClass('active');
				$(this).addClass('active');

				isActiveTab();
			};

		});


		// show Custom Fit TAB after click on button
		$(document).on('click', '#custom_fit', function() {
			$(this).removeClass('setProduct');
			$('.driversTabs > ul > li').removeClass('active');
			$('.driversTabs ul li:last-child').addClass('active');
			isActiveTab();

			// scroll to Custom Fit TAB
			$('html, body').animate({
	        	scrollTop: $("#scroll_to_driversTabs").offset().top
			}, 400);
		});

		
		$('.item_stock.store').mouseover(function(){
			$(this).tipsy({
				'title': function(){
					return $(this).html();
				},
				'className': 'store_availability',
				'html': true,
				'trigger': 'manual',
				'gravity': 'south'
			});
			$(this).tipsy('show');
		}).mouseout(function(){
			$(this).tipsy('hide');
		});
		
		$('.rank_items_notext .rank_rate .rating_item').each(function(){
			$(this).tipsy(
				{
					gravity: 'e',
					fallback: $(this).find('span').text()
				}
			);
		});
		
		// why? the cart should load on every page it's needed, by default
		//digitalgolf.order.cart.update(true);
		
		try {
			$.openxtag(
				'init',
				{
					delivery: cyclone3.ads,
					deliverySSL: cyclone3.ads_ssl
				}
			);
			$('.banner.openx').openxtag('zone', function () {

			});
		}catch(e){}
		
		/*
		 * menu
		 */
		$(".nav__main .menu > li").mouseenter(function()
		{
			var t = $(this);
			t.find('> ul').addClass("show");
			if ($(".nav__main .submenu.show").length){
				t.parents('.nav__main').addClass("subnav-show");
			};
		});
		$(".nav__main .menu > li").mouseleave(function() {
			$(this).find('> ul').removeClass("show");
			$(this).parents('.nav__main').removeClass("subnav-show");
		});
		
		$('#site_head .btn__search')
			.click(function(){
				$('#search_wrapper').addClass('open');
				$('#mask').show();
				$('#headsearch_query').focus();
			});

		$('#site_head .search input')
			.keyup(function(event){
				var key = event.keyCode || event.which;
				
				if (key === 13) {
					//automatically submitted
				}else{
					window.clearTimeout(digitalgolf.product.list.searchTimer);
					digitalgolf.product.list.searchTimer = window.setTimeout(
						digitalgolf.product.list.search,
						500
					);
				}
			});

		$('#search_wrapper .close').click(function(){
			$('#search_wrapper .items').empty();
			$('#mask').hide();
		});

		$(document).click(function(e) {
			if (!$(e.target).closest("#search_wrapper").length) {
				$("#search_wrapper .items").empty();
			}
		});

		$("#search_wrapper form.search").on("submit", function(e) {
			if ($("#headsearch_query").val().length < 2) e.preventDefault();
		});
		
		var loginBtn = $("header a.login");
		var loginPopup = $("header .login_popup");
		
		loginBtn.click(function(event)
		{
		  // hide
			if ($(this).hasClass('on'))
			{
				$(this).removeClass('on').addClass('off');
				$(this).parent().removeClass('on').addClass('off');
				loginPopup.hide(0);
				$('#mask').hide();
			}
			
			// show
			else if($(this).hasClass('off'))
			{
				$(this).removeClass('off').addClass('on');
				$(this).parent().removeClass('off').addClass('on');
				loginPopup.show(0);
				$('#mask').show();
			}
			
			cyclone3.cancelEvent(event);
		});
	
		$('.login_popup .close').click(function() {
			loginBtn.trigger('click');
		});
		
		$('.form.standard .invalid input').focus(function(){
			digitalgolf.form.input.help.show(this);
		}).blur(function(){
			digitalgolf.form.input.help.hide(this);
		});
	
		$('input').each(function(){
			if($(this).is(':disabled')){
			  $(this).parent().addClass('disabled');
			}
		});
		
		createOwlSlider();
		
		initGoogleMaps();
		initYouTubeVideos();
		
		if (digitalgolf.pageData.scrollTopEnable) {
			//Check to see if the window is top if not then display button
			//show only for product detail and product listings
			$(window).scroll(function(){
				if ($(this).scrollTop() > 100) {
					$('.scrollToTop').fadeIn();
				} else {
					$('.scrollToTop').fadeOut();
				}
			});
		}
		
		$('.product_media .zoomable').mouseenter(function(){
			canhidezoom=false;
			//cyclone3.log('canhidezoom set:'+canhidezoom)
		}).mouseleave(function(){
			canhidezoom=true;
			//cyclone3.log('canhidezoom set:'+canhidezoom)
		});
		
		//Click event to scroll to top
		$('.scrollToTop').click(function(){
			$('html, body').animate({scrollTop : 0},800);
			return false;
		});
		
		$('footer .newsletter_submit').click(function(){
			$('footer .newsletter_wrap input').removeClass('error');
			$('footer .label_check').removeClass('label_check--error');
			var accept = $('footer input[name="agree_protection"]').prop("checked");
			if(accept == false){
				$('footer .label_check').addClass('label_check--error');
				return false;
			}
			if(accept == true){
				if (digitalgolf.toolbox.checkMailFormat($('footer .newsletter_wrap input').val()))
				{
					$.ajax(
					{
						type: "POST",
						url: cyclone3.domain + '/xml/' + cyclone3.lng + '/newsletter/subscribe',
						data: {
							'email': $('footer .newsletter_wrap input').val()
						},
						dataType: 'xml',
						xhrFields: {
							withCredentials: true
						},
						success: function(data){
							try{
								$('footer .newsletter_wrap').addClass('submitted');
							}catch(e){
								cyclone3.log('[newsletter submit] error ' + e);
							}
						}
					});
				}
				else
				{
					$('footer .newsletter_wrap input').addClass('error');
				}
			}
		});
		
		
		$(".free_delivery.panel a.close").click(function(){
			$(".free_delivery.panel").fadeOut();
		});
		
		if($("#sort")[0])
		{
			var sortMatch = document.location.hash.match(/sort=(.*?_.*?sc)/);
			if(sortMatch)
			{
				$("#sort option").filter(function() {
					return $(this).val() == sortMatch[1];
				}).prop('selected', true);
			}else{
				//effin chrome bugs!!!
				if($('#sort').val() != $('#sort option[selected]').val())
				{
					$('#sort').val($('#sort option[selected]').val());
				}
			}
		}
		
		//$('select#sort, select#f_country_code').selecter();
		
		$('#sort').change(function(){
			if (digitalgolf.setup.useInfiniteLoader)
			{
				digitalgolf.pageData.page = 1;
				digitalgolf.product.list.load();
				//digitalgolf.toolbox.setUriHash(digitalgolf.product.filter.getParams());
			}
			else
			{
				digitalgolf.toolbox.setUri(digitalgolf.product.filter.getParams());
			}
		});
		
		$('#price_min, #price_max').keyup(function(){
			window.clearTimeout(loadtimeout);
			loadtimeout = window.setTimeout(function() {
				digitalgolf.pageData.page = 1;
				digitalgolf.product.facet.update();
			}, 1000);
		});
		
		$("form#filterTop input[type='checkbox']").change(function(){
			digitalgolf.pageData.page = 1;
			digitalgolf.product.facet.update();
		});
		
		$("#facet").show();
			
		digitalgolf.product.facet.initialize(true);
		
		/* LNG CHANGING */
		$(".lng select").selecter(
		 {
			 customClass: "lng_select"
		 });
		
		$('.lng select').change(function() {
			location = this.options[this.selectedIndex].value;
		});
	}
);

$(window).resize(function() {
	if ($(window).width() < 1000)
	{
		var prodDesc = $( ".page_frame.product_view.v2014 .product_description").height() + 60;
		var prodHead = $( ".page_frame.product_view.v2014 .product_heading").height() + 30;
		var ordBox = $( ".page_frame.product_view.v2014 .orderbox").height() + 45;
		
		$( ".product_view.v2014 .order_panel, .product_view.v2014 .order_panel").css('top', prodDesc + prodHead + 55);
		
		$( ".product_view.v2014 .product_description").css('margin-bottom', ordBox + 200);
	}
});

window.addEventListener("load", function()
{
	(function(){if(typeof(Storage)!=="undefined"){
 		if(!ESP.usrmevent){
 			var request=new XMLHttpRequest();
	 			request.open('GET','/json/esp',true);
	 			request.onload = function (e) {
				  	if (request.readyState === 4) {
				    	if (request.status === 200) {
				    		ESP=JSON.parse(request.responseText);
				    		sessionStorage.C3esp=request.responseText;
				    	} else {}
				  	}
				};
			request.send(null);
 		}
 		
 		if (ESP.usrmevent){
 			// display/hide entities by segments
 			
 		}

 	}else{}})(window,document);
	//console.log('load');
});

function g_addToCart(item, amount){
	dataLayer.push({ 
		'event': 'addToCart',
		'ecommerce': {
			'currencyCode': $(item).data("currency"),
			'add': {
				'products': [{
					'name': $(item).data("name"),
					'id': $(item).data("id"),
					'price': $(item).data("price"),
					'brand': $(item).data("brand"),
					'category': $(item).data("category"),
					'variant': $(item).data("variant"),
					'quantity': amount
				}]
			}
		},
		'id': $(item).data("id"),
		'name': $(item).data("name"),
		'price': $(item).data("price"),
		'brand': $(item).data("brand"),
		'category': $(item).data("category"),
		'currency': $(item).data("currency"),
		'variant': $(item).data("variant"),
		'quantity': amount
	});	
}
		
function g_removeFromCart(ID){
	dataLayer.push({   
		'event': 'removeFromCart',
		'ecommerce': {
			'remove': {
				'products': [{
					'id': ID,
					'quantity': 1
				}]
			}
		},
		'id': ID
	});
}

// SHOW - HIDE product filter after click
function showHideFilter() {
	if($(window).width() < 1000) {
		$('.checkboxes dd').css('display', 'none');
		$('dt').click(
			function() {
				$(this).toggleClass('arrow-reverse');
				$(this).nextAll('dd').slideToggle();
			}
		);
	} else {
		$('.checkboxes dd').css('display', 'block');
	}
}

$(function() {
	
	//Nav banner
	//Execute on desktop only
	if ($(document).width() > 1023){
		
		//mouseover main nav item
		$(document).on('mouseover', '[data-js-sub]:not([data-js-has-banner])', function(){
			var t = $(this),
				t_id = t.data('js-sub'),
				t_name = t.data('js-sub-name');
				t_url = t.find('[data-js-sub-nav-banner]').data('js-sub-nav-url');
	
			//main nav item has sub
			if ($('[data-js-sub-nav-banner=' + t_id + ']').length){
				
				var t_sub = $('[data-js-sub-nav-banner=' + t_id + ']');	
				var ajaxUrl = t_url;
				
				//Ajax Start
				$.ajax({
						url: ajaxUrl,
						type: 'GET',
						dataType: 'json'
					})
					.done(function (data) {
						if ($(data).length) {
							//console.log(data);
							t_sub.html(data[0].html).fadeOut(0).fadeIn(300);

							dataLayer.push({
								'event': 'promoView',
								'ecommerce': {
									'promoView': {
										'promotions': [{
											'id': data[0]['id'],
											'name': data[0]['name'],
											'position': 'menu'
										}]
									}
								}
							});

						} else {
							t_sub.hide();
							//console.log("stop");
							stopRequests = true;
						}
					})
					.fail(function (e) {
						t_sub.hide();
						//console.log("fail");
						stopRequests = false;
					})
					.always(function () {
						//set main nav item visited state
						t.attr('data-js-has-banner', '');
						//console.log("always");
						processing = false;
					});
				//Ajax End
				
			};
	
		});
	};

	/* dropdown "button" filters */
	$(document).on("click","#facet button.dropdown-toggle",function(e) {
		e.preventDefault();
		
		var dropdown = $(this).parent();
		dropdown.siblings().removeClass('open');
		dropdown.toggleClass('open');

		//scroll to filter list 
		$('html,body').animate({
			scrollTop: $("#facet").offset().top - 34}, //padding + margin + 10
			'slow');

	});
	
	$(document).on("click","#facet button.save",function(e) {
		e.preventDefault();
		digitalgolf.pageData.page = 1;
		digitalgolf.product.facet.update();	
		$(document).find('#facet .dropdown').each(function() { 
			$(this).removeClass('open');
	   });	
	});
	
	$(document).on("click","button#load-more",function(e) {
		e.preventDefault();
		digitalgolf.product.list.loadMore();
	});
	$(document).on("click",".filter-tags a",function(e) {
		e.preventDefault();
		if ($(this).data("filter-name") == "all") {
			
            $(document).find('#facet input').each(function() { 
				$(this).prop("checked", false);
			});
			$(document).find("#price_min").val("");
			$(document).find("#price_max").val("");
			$("form#filterTop input[type='checkbox']").prop("checked", false);
			
			$(".filter-tags li").remove();
			
        } else if ($(this).data("filter-name") == "price_from") {
			
			$(document).find("#price_min").val("");
			
		} else if ($(this).data("filter-name") == "price_to") {
			
			$(document).find("#price_max").val("");
		
		} else if ($(this).data("filter-name") == "VPrvelskot") {
			
			$(document).find("input[value='"+$(this).data("filter-value	")+"']").prop("checked", false);
		
		} else if ($(this).data("filter-name") == "main") {
			
			$(document).find("#p_main_"+$(this).data("filter-value")).prop("checked", false);
			
		} else {
			
			$(document).find("#" + $(this).data("filter-name") + "_" + $(this).data("filter-value")).prop("checked", false);
			
		}
		
		$(this).parent().remove();
		digitalgolf.pageData.page = 1;
		digitalgolf.product.facet.update();
	});

//OWL2 Carousel HP	
	$('[data-js-owl2="hp"]').owlCarousel({
		loop: true,
		autoplay: true,
		autoplayTimeout: 3000,
		margin: 20,
		nav: true,
		navContainer: '[data-js-owl2="hp-navContainer"]',
		dots: false,
		responsive:{
			0:{
				items: 2
			},
			600:{
				items: 3
			},
			1000:{
				items: 5
			}
		}
	});


	//OWL2 Carousel Product detail	
	$('[data-js-owl2="product_detail"]').owlCarousel({
		margin: 0,
		nav: true,
		dots: false,
		navText: [
			'<span aria-label="Previous">‹</span>',
			'<span aria-label="Next">›</span>'
		],
		navContainer: '[data-js-owl2="product_detail-navContainer"]',
		responsive:{
			0:{
				items: 3
			},
			768:{
				items: 6
			}
		}
	});
	//OWL2 Carousel category menu with images	
	$('[data-js-owl2="category_menu"]').owlCarousel({
		margin: 8,
		nav: true,
		dots: false,
		autoWidth: true,
		navText: [
			'<svg fill="currentColor" height="24px" width="24px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 55.752 55.752" xml:space="preserve" transform="matrix(-1, 0, 0, 1, 0, 0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M43.006,23.916c-0.28-0.282-0.59-0.52-0.912-0.727L20.485,1.581c-2.109-2.107-5.527-2.108-7.637,0.001 c-2.109,2.108-2.109,5.527,0,7.637l18.611,18.609L12.754,46.535c-2.11,2.107-2.11,5.527,0,7.637c1.055,1.053,2.436,1.58,3.817,1.58 s2.765-0.527,3.817-1.582l21.706-21.703c0.322-0.207,0.631-0.444,0.912-0.727c1.08-1.08,1.598-2.498,1.574-3.912 C44.605,26.413,44.086,24.993,43.006,23.916z"></path> </g> </g></svg>',
			'<svg fill="currentColor" height="24px" width="24px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 55.752 55.752" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M43.006,23.916c-0.28-0.282-0.59-0.52-0.912-0.727L20.485,1.581c-2.109-2.107-5.527-2.108-7.637,0.001 c-2.109,2.108-2.109,5.527,0,7.637l18.611,18.609L12.754,46.535c-2.11,2.107-2.11,5.527,0,7.637c1.055,1.053,2.436,1.58,3.817,1.58 s2.765-0.527,3.817-1.582l21.706-21.703c0.322-0.207,0.631-0.444,0.912-0.727c1.08-1.08,1.598-2.498,1.574-3.912 C44.605,26.413,44.086,24.993,43.006,23.916z"></path> </g> </g></svg>'
		],
		navContainer: '[data-js-owl2="category_menu"] .owl-stage-outer',
		nInitialized: hideNavIfEdge,
    	onTranslated: hideNavIfEdge
	});

	function hideNavIfEdge(event) {
		let $prev = $('.owl-prev');
		let $next = $('.owl-next');
		
		if (event.item.index === 0) {
			$prev.hide();
		} else {
			$prev.show();
		}
	
		if (event.item.index + event.page.size >= event.item.count) {
			$next.hide();
		} else {
			$next.show();
		}
	}

	if($(window).width() < 768) {
		if ($(".product_gallery .owl-stage").children().length < 4) {
			$(".product_gallery .owl__nav ").hide();
		}
	} else {
		if ($(".product_gallery .owl-stage").children().length < 7) {
			$(".product_gallery .owl__nav ").hide();
		}
	}
})

// sticky nav__main
$(window).bind('scroll', function () {

    if ($(window).scrollTop() > 33) {
		$('#site_head').addClass('sticked');
    } else {
		$('#site_head').removeClass('sticked');
    }
})

// Mobile menu toggle
// Productlist Filters toggle
$(document).on('click', '[data-js-toggle]', function(){
	var tgt = $(this).data('js-toggle'),
		tgt_el = $('[data-js-target="'+ tgt +'"]'),
		fix = $(this).data('js-scrollfix'),
		fix_el = $(fix);

	$(this).toggleClass('open');
	tgt_el.toggleClass('open');
	fix_el.toggleClass('scroll-fix');
});

//HP banner slider
$(document).ajaxSuccess(function(){
	if($('.banner_slider').length){

		$('.banner_slider .banner__placeholder').remove();

		if ($('.banner_slider .item').length > 1){

			$('.banner_slider').owlCarousel({
				loop: true,
				autoplay: true,
				items: 1,
				autoplayTimeout: 5000,
				smartSpeed: 1000,
				margin: 0,
				nav: false,
				dots: true
			});

		};

	}
});

// product detail quantity
$(document).ready(function(){
	$('<div class="input-group-nav"><div class="input-group-button input-group-up">+</div><div class="input-group-button input-group-down">-</div></div>').insertAfter('.input-group input');
	$('.input-group').each(function() {
		var spinner = $(this),
			input = spinner.find('input[type="number"]'),
			btnUp = spinner.find('.input-group-up'),
			btnDown = spinner.find('.input-group-down'),
			min = input.attr('min'),
			max = input.attr('max');

		btnUp.click(function() {
			var oldValue = parseFloat(input.val());
			if (oldValue >= max) {
			var newVal = oldValue;
			} else {
			var newVal = oldValue + 1;
			}
			spinner.find("input").val(newVal);
			spinner.find("input").trigger("change");
		});

		btnDown.click(function() {
			var oldValue = parseFloat(input.val());
			if (oldValue <= min) {
			var newVal = oldValue;
			} else {
			var newVal = oldValue - 1;
			}
			spinner.find("input").val(newVal);
			spinner.find("input").trigger("change");
		});
	});
});
 
$(document).ready(function(){
	if( $("input.validate_tel").length > 0){
		
		var iti_style =  document.createElement('link');
	
		// set css
		iti_style.setAttribute('href', cyclone3.domain + '/media/eshop_css/intlTelInput.min.css');
		iti_style.setAttribute('type','text/css');
		iti_style.setAttribute('rel','stylesheet');
		
		//append css
		document.head.appendChild(iti_style);

		//get script
		$.getScript( cyclone3.domain + "/media/eshop_js/intlTelInput-jquery.min.js" )
			.done(function( script, textStatus ) {
				
				$("input.validate_tel").each(function() {
					
					var input = $(this),
						id = $(input).attr('id'),
						hidden_input = "complete_"+id,
						form = $(input).closest("form"),
						parent = $(input).closest(".phone-col");
					//console.log("tel inpunt "+id);
					input.after('<span id="error-msg-'+id+'" class="error-msg-phone" style="display:none"></span>');
					var errorMsg = $('#error-msg-'+id);
					var initCountry = "sk";
					if (typeof country_code !== 'undefined') {
						initCountry = country_code;
					}
					
					input.intlTelInput({
						onlyCountries: [
							"at", "be", "bg", "hr", "cz", "dk", "ee", "fi", "fr",
							"de", "gr", "hu", "ie", "it", "lv", "lt", "lu", "nl",
							"pl", "pt", "ro", "sk", "si", "es", "se", "gb"
						],
						initialCountry: initCountry,
						hiddenInput: hidden_input,
						utilsScript: "/media/eshop_js/utils.js?1562189064761"
					});
					
					var resetPhoneValidation = function() {
						input.removeClass("error");
						errorMsg.innerHTML = "";
						errorMsg.hide();
					};
					
					input.on('blur', function () {
						resetPhoneValidation();
							
						if (input.val().trim()) {
							if (input.intlTelInput("isValidNumber")) {
								form.find('.submit-form').prop('disabled', false).removeClass('disabled');
								parent.removeClass("invalid").addClass("valid");
								form.find('input[name="f_text_telefon_full"]').val(input.intlTelInput("getNumber"));
								form.find('input[name="'+hidden_input+'"]').val(input.intlTelInput("getNumber"));
							} else {
								form.find('.submit-form').prop('disabled', true).addClass('disabled');
								parent.removeClass("valid").addClass("invalid");
								errorMsg.text(getL10n('Invalid phone number', cyclone3.lng));
								errorMsg.show();
							}
						}
					});
					
					input.on('change', resetPhoneValidation());
					input.on('keyup', resetPhoneValidation());
				});
			})


	};
});


$(document).ready(function(){
	if ($(".discount_timer").length) {
		//mozem mat duplicitny timer (v hlavicke aj v detaile preto zoberiem hodnotu len z prveho aby som zbytocne nemusel pocitat duplicitne)
		var endTime = $(".discount_timer-end-time").first();
		var countDownDate = new Date(endTime[0].value).getTime();
		//selektnem vsetky .time-calc v ktorych budem updatovat cas
		var time_calc_el = $(".discount_timer-actual .time-calc")

		var x = setInterval(function() {

			// Get today's date and time
			var now = new Date().getTime();
				
			// Find the distance between now and the count down date
			var distance = countDownDate - now;
				
			// Time calculations for days, hours, minutes and seconds
			var days = Math.floor(distance / (1000 * 60 * 60 * 24));
			var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			var seconds = Math.floor((distance % (1000 * 60)) / 1000);
				
			// Output the result in an element
			outputResult(time_calc_el);
			
			function outputResult(time_calc_el) {
				$(time_calc_el).html(days + "d " + hours + "h " + minutes + "m " + seconds + "s ");
			}
				
			// If the count down is over, write some text  // netreba kedže ked neni zlava nezobrazí sa dané okno
			if (distance < 0) {
				clearInterval(x);
				$('.discount_timer-actual').hide();
				$('.discount_timer-expired').removeClass("d-none");
			}
		}, 1000);
	}

});

$(function() {
    $(document).on('change', '#order_quantity', function() {
        const inputElement = $(this);
		// modification or single product? need to specify discount container with ID
		const selected_modification = $('#selected_modification [data-option]:checked');
		let container  = $('#quantity-discount-'+selected_modification.val());
		let el_location = "detail";
		if (inputElement.closest('.popup--quantity-discount').length) {
			container = inputElement.closest('.popup--quantity-discount');
			el_location = "cart";
		}		
        const quantityDiscountContainer = container.find('.discount_group');
		const count = parseInt(inputElement.val(), 10);
        
		// price without discount		
		let standardPrice = parseFloat($('.product_pricing').data('product-price'));
		let currency_symbol = $('.product_pricing').data('currency-symbol');
		if (el_location == "cart") {
			 standardPrice = parseFloat(container.find('#checkout_popup_price').data('product-price'));
			 currency_symbol = container.find('#checkout_popup_price').data('currency-symbol');
		}

		// new - discounted - price
        const productPrice = quantityDiscountContainer.length 
            ? calculatePrice(count, container)
            : standardPrice;
		
        const price = count * productPrice;
        const price_before_qnt_disc = count * standardPrice;
        const priceFull = Math.floor(price).toString();
        const priceCent = ((price.toFixed(2)).toString()).split('.')[1];
        const savedAmount = (standardPrice - productPrice) * count;
		container.find('.saved_amount').text(savedAmount.toFixed(2).replace('.', ',') + ' ' + currency_symbol);
		
		// updating total price - product detail
		if (el_location == "detail") {
			$('.full-detail').text(priceFull);
			if (priceCent === '00') {
				$('.line, .cent-detail').hide();
			} else {
				$('.line, .cent-detail').show();
				$('.cent-detail').text(priceCent);
			}
			
			// product detail - need to update data-price, it is used for add to cart fnc
			$('#selected_modification [data-option]:checked').data('price', productPrice);
		}
		
		// updating total price - cart
        if (el_location == "cart") {
			container.find('#checkout_discounted_price').text(price.toFixed(2) + ' ' + currency_symbol);
			container.find('#checkout_popup_price').text(price_before_qnt_disc.toFixed(2) + ' ' + currency_symbol);
			if (savedAmount == 0) {
				container.find('#checkout_popup_price').hide();
			} else {
				container.find('#checkout_popup_price').show();
			}
		}

		// calculate the price with the quantity discount
        function calculatePrice(quantity, container) {
            let unitPrice = 0;
            container.find('.discount_group').each(function() {
                const group = $(this);
                const quantityFrom = parseInt(group.find('.quantity').data('qntfrom'), 10);
                const quantityTo = parseInt(group.find('.quantity').data('qntto'), 10);

                if (quantity >= quantityFrom && quantity <= quantityTo) {
                    unitPrice = parseFloat(group.find('.discount_price').data('discount-price'));
                    container.find('.discount_group').removeClass('selected');
                    group.addClass('selected');
                }
            });
			
			//	no unit price, using standard product price without discount
            if (unitPrice === 0) {
                unitPrice = $('.product_pricing').data('product-price');
                if (!unitPrice) {
                    unitPrice = container.find('#checkout_popup_price').data('product-price');
                }
                container.find('.discount_group').removeClass('selected');
            }
			
            return unitPrice;
        }
    });
	
    // Handle confirm button click
    $(document).on('click', '#confirm_btn', function() {
		
		// Find the relevant item-detail container
        const container = $(this).closest('.popup--quantity-discount');
		const itemId = container.data("popup-prodid");
		const itemUid = container.data("popup-produid");		
        const itemDetail = $('#item-detail-' + itemId + '-' + itemUid);
		
		const count = parseInt(container.find('#order_quantity').val(), 10);
		itemDetail.find('input[type="number"]').val(count).attr('value', count);
		
		// Close the popup
        container.fadeOut(200).removeClass('open');
        $('#mask').fadeOut(200).removeClass('open');
        $(document.body).removeClass('scroll-stop');
    });
});

function openItemQuantityPopup(id) {
	
	const modalSelector = '#popup-' + id;	
	
	// Show the modal - added to cart
	$(modalSelector + ', #mask').fadeIn(200).addClass('open');

	// Add class to prevent body scroll
	$(document.body).addClass('scroll-stop');

	// Synchronize the input value
	const itemDetailInputValue = $('#item-detail-' + id).find('input[type="number"]').val();
	const modalInput = $(modalSelector).find('#order_quantity');
	modalInput.val(itemDetailInputValue);

	// Trigger change event to highlight the correct discount group and calculate the price
	modalInput.trigger('change');

	// Remove scroll-stop class when clicking close or outside the popup
	$('#mask.open, [data-js-popup-dismiss]').click(function() {
		$(modalSelector + ', #mask').fadeOut(200).removeClass('open');
		$(document.body).removeClass('scroll-stop');
	});
}

function switchQuantityDisc(id) {
	
	let currency_symbol = $('.product_pricing').data('currency-symbol');
	
	// first reset quantity discount boxes for all modifications
	$(".quantity_discount").each(function() { 
		$(this).hide();
		$(this).find(".discount_group.selected").removeClass("selected");
		$(this).find('.saved_amount').text('0.00 ' + currency_symbol);
	});
	
	// if exist quantity discount for prod (modification) ID, show..
	if ($("#quantity-discount-"+id).length) {
		$("#quantity-discount-"+id).show();
	}
}

function onPromoClick(promoObj) {
	event.preventDefault();
	var already_redirected = 0;
	dataLayer.push({
		'event': 'promotionClick',
	    'ecommerce': {
			'promoClick': {
				'promotions': [
					{
						'id': promoObj.id,
	                    'name': promoObj.name,
	                    'creative': promoObj.creative,
	                    'position': promoObj.pos
					}]
				}
			},
			'eventCallback': function() {
				if (!already_redirected){
					document.location = promoObj.destinationUrl;
					already_redirected = 1;
				}
	    }
	});
};

function setupUrlPage(page) {
	var current_url = new URL(window.location);
	current_url.searchParams.set('page', page);
	// replace history url & url in browser address bar
	window.history.replaceState({}, '', current_url);
};

$(document).ready(function(){
	if ($('#switch_eu').length && $('#switch_uk').length){
		$(".size_eu").hide();
		$("#switch_uk").addClass("active");
		$("#switch_eu").click(function(){
			$("#switch_uk").removeClass("active");
			$(this).addClass("active")
			$(".size_eu").show().addClass("active");
			$(".size_uk").hide().removeClass("active");
		});
		$("#switch_uk").click(function(){
			$("#switch_eu").removeClass("active");
			$(this).addClass("active")
			$(".size_eu").hide().removeClass("active");
			$(".size_uk").show().addClass("active");
		});
	}
	
});

// GA4 search measurement used for autosuggest and fullpage search
function dataLayerEventSearch(query, type, products, categories) {
	dataLayer = dataLayer || [];
	dataLayer.push({
		'event': 'search',
		'search': {
			'query': query,
			'type': type,
			'results': {
				'products':  products,
				'categories': categories
			}
		},
		_clear: true
	});
}
